import { hex2rgba } from './hex2rgba';
import { rgbStringToArray } from './rgb-string-to-array';
import { getLightShadeForStrokeColor } from './utils';
const BLACK = '#000000';
const WHITE = '#FFFFFF';
const parseToRgb = (color: string): [number, number, number] | undefined => {
  if (color.startsWith('#')) {
    try {
      const [r, g, b] = hex2rgba(color, 1);
      return [r, g, b];
    } catch {
      return undefined;
    }
  }
  if (color.startsWith('rgb(') || color.startsWith('rgba(')) {
    /*
     * rgbStringToArray only accepts up to 3 comma-separated values,
     * so drop the alpha channel before parsing.
     */
    const [r = '0', g = '0', b = '0'] = color.replace(/rgba?\(/, '').replace(')', '').split(',').map(value => value.trim());
    const rgb = rgbStringToArray(`rgb(${r},${g},${b})`);
    return Array.isArray(rgb) ? rgb : undefined;
  }
  return undefined;
};

/*
 * WCAG-style relative luminance (sRGB weights), used to pick a readable
 * text/accent color for an arbitrary background rather than relying on a
 * fixed lookup table that only covers a fixed set of colors. Falls back to
 * black when the color can't be parsed.
 */
export const getContrastTextColor = (backgroundColor: string): string => {
  const rgb = parseToRgb(backgroundColor);
  if (!rgb) {
    return BLACK;
  }
  const [r, g, b] = rgb;
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.5 ? BLACK : WHITE;
};

/*
 * Accent color to pair with a given color so the two remain visually
 * distinct. Uses a curated lookup for known colors when available, and
 * falls back to a computed black/white contrast otherwise, so the accent
 * never ends up indistinguishable from the color it's paired with.
 */
export const getAccentColorForStroke = (strokeColor: string): string => getLightShadeForStrokeColor(strokeColor) ?? getContrastTextColor(strokeColor);